import { SagaIterator } from 'redux-saga'
import * as effects from 'redux-saga/effects'
import * as api from './api'
import * as actions from './actions'
import { formatErrorMessage } from '../../utils/helpers'
import * as Sentry from '@sentry/react'

function* fetchModulesList(payload: { id: string }): SagaIterator {
  try {
    const courses = yield effects.call(api.fetchModulesList, payload.id)
    yield effects.put(actions.fetchModulesListSuccess(courses.data))
  } catch (error) {
    console.warn('Cannot fetch modules list', error)
    yield effects.put(
      actions.fetchModulesListFailure(formatErrorMessage(error))
    )
    Sentry.captureException(error)
  }
}

function* removeModule(payload: { id: string; mid: string }): SagaIterator {
  try {
    const { id, mid } = payload
    yield effects.call(api.removeModule, id)
    yield effects.put(actions.removeModuleSuccess())
    yield effects.put(actions.fetchModulesList(mid))
  } catch (error) {
    console.warn('Cannot remove module', error)
    yield effects.put(actions.removeModuleFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* createModuleRelation(payload: {
  id: string
  sourceId: string
  targetId: string
  relationType: string
}): SagaIterator {
  try {
    const { id, sourceId, targetId, relationType } = payload
    yield effects.call(
      api.createModuleRelation,
      sourceId,
      targetId,
      relationType
    )
    yield effects.put(actions.createModuleRelationSuccess())
    yield effects.put(actions.fetchModulesList(id))
  } catch (error) {
    console.warn('Cannot create module relation', error)
    yield effects.put(
      actions.createModuleRelationFailure(formatErrorMessage(error))
    )
    Sentry.captureException(error)
  }
}

function* editModuleRelation(payload: {
  id: string
  relationId: string
  sourceId: string
  targetId: string
  relationType: string
}): SagaIterator {
  try {
    const { id, relationId, sourceId, targetId, relationType } = payload
    yield effects.call(
      api.editModuleRelation,
      relationId,
      sourceId,
      targetId,
      relationType
    )
    yield effects.put(actions.editModuleRelationSuccess())
    yield effects.put(actions.fetchModulesList(id))
  } catch (error) {
    console.warn('Cannot edit module relation', error)
    yield effects.put(
      actions.editModuleRelationFailure(formatErrorMessage(error))
    )
    Sentry.captureException(error)
  }
}

function* removeModuleRelation(payload: {
  id: string
  mid: string
}): SagaIterator {
  try {
    const { id, mid } = payload
    yield effects.call(api.removeModuleRelation, id)
    yield effects.put(actions.removeModuleRelationSuccess())
    yield effects.put(actions.fetchModulesList(mid))
  } catch (error) {
    console.warn('Cannot remove module relation', error)
    yield effects.put(
      actions.removeModuleRelationFailure(formatErrorMessage(error))
    )
    Sentry.captureException(error)
  }
}

function* watchFetchModulesList(): SagaIterator {
  yield effects.takeEvery(actions.fetchModulesList.toString(), fetchModulesList)
}

function* watchRemoveModule(): SagaIterator {
  yield effects.takeEvery(actions.removeModule.toString(), removeModule)
}

function* watchCreateModuleRelation(): SagaIterator {
  yield effects.takeEvery(
    actions.createModuleRelation.toString(),
    createModuleRelation
  )
}

function* watchEditModuleRelation(): SagaIterator {
  yield effects.takeEvery(
    actions.editModuleRelation.toString(),
    editModuleRelation
  )
}

function* watchRemoveModuleRelation(): SagaIterator {
  yield effects.takeEvery(
    actions.removeModuleRelation.toString(),
    removeModuleRelation
  )
}

export default function* watchFetchModulesPage(): SagaIterator {
  yield effects.all([
    effects.fork(watchFetchModulesList),
    effects.fork(watchRemoveModule),
    effects.fork(watchCreateModuleRelation),
    effects.fork(watchEditModuleRelation),
    effects.fork(watchRemoveModuleRelation),
  ])
}
